export const version = {
  VERSION_CODE : 'v.21022023'
};
